import React from "react";

const SkillCard = ({ img }) => {
  const { name, icon_url } = img;
  return (
    <div
      data-aos="zoom-out-up"
      data-aos-duration="1500"
      className="hover:bg-zinc-300 p-10 "
    >
      <button className="w-[135px] h-[135px]">
        <span>
          <img className=" w-full" src={icon_url} alt="" />
          <h2 className="text-2xl font-semibold text-lime-500	mt-5">{name}</h2>
        </span>
      </button>
    </div>
  );
};

export default SkillCard;
